import React from 'react';
import CustomerPortfolio from 'components/Tvendo/Sale/DataMaster/CustomerPortfolio/List.js';

export default function () {
  return <CustomerPortfolio />;
}
